import { useCallback, useEffect, useState } from "react";

import { useAuth } from "@modules/auth";

import loadDefaultAddress from "../../services/loadDefaultAddress";
import type { TDefaultAddress } from "../../types";

const useDefaultUserAddress = (): {
  address: TDefaultAddress | undefined;
  isLoadingAddresses: boolean;
} => {
  const [address, setAddress] = useState<TDefaultAddress>();
  const [isLoadingAddresses, setIsLoadingAddresses] = useState(false);

  const { isLoggedIn } = useAuth();

  const loadAddress = useCallback(async () => {
    setIsLoadingAddresses(true);
    const userAddress = await loadDefaultAddress();
    setIsLoadingAddresses(false);
    setAddress(userAddress || undefined);
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      loadAddress();
    }
  }, [isLoggedIn, loadAddress]);

  return { address, isLoadingAddresses };
};
export default useDefaultUserAddress;
